import { render, staticRenderFns } from "./DSExportIcon.vue?vue&type=template&id=0765ac15&scoped=true&"
import script from "./DSExportIcon.vue?vue&type=script&lang=js&"
export * from "./DSExportIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0765ac15",
  null
  
)

export default component.exports